import { GetAgreementFilesResult, getAllAgreementFiles } from 'application/adapters/agreements/agreementsAdapter';
import { getCMSHostname } from 'helpers/getCMSHostname';
import logger from 'helpers/logger';
import React, { useEffect, useState } from 'react';
import { ListAgreements } from 'ui/components';

export const ListAgreementsFeature: React.FC<Umbraco.ListAgreements> = ({ content }) => {
	const [agreements, setAgreements] = useState<GetAgreementFilesResult[]>([]);

	useEffect(() => {
		getAllAgreementFiles(getCMSHostname())
			.then((response) => {
				const agreementsData = Array.isArray(response.data) ? response.data : [response.data];
				setAgreements(agreementsData);
			})
			.catch((error) => {
				logger.error(error);
			});
	}, []);

	return <ListAgreements {...content?.properties} agreements={agreements} />;
};
